import { render } from "./SearchCourse.vue?vue&type=template&id=1d3b37b4"
import script from "./SearchCourse.vue?vue&type=script&lang=js"
export * from "./SearchCourse.vue?vue&type=script&lang=js"

import "./SearchCourse.vue?vue&type=style&index=0&id=1d3b37b4&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__